/* eslint-disable @typescript-eslint/naming-convention */
import type { IGroupExtension, ILayerBehavior, ILayerProps, LayerType } from '@/version-types';
import { getGroupExtension, type IService } from '../../shared';

export class BehaviorService implements IService {
    private __behaviors: Record<string, ILayerBehavior> = {};

    constructor() {}

    onInit() {}

    /**
     * 获取图层行为的键
     * @param layerOrLayerType - 图层或图层类型
     * @param role - 组图层的角色
     * @returns 图层行为的键
     */
    getKey(layerOrLayerType: ILayerProps | LayerType, role?: string) {
        if (typeof layerOrLayerType === 'string') {
            return this.__createKey(layerOrLayerType, role);
        }
        const extension = getGroupExtension<IGroupExtension>(layerOrLayerType);
        return this.__createKey(layerOrLayerType.layerType, extension?.role);
    }

    /**
     * 获取图层行为
     * @param layerOrLayerType - 图层或图层类型
     * @returns 图层行为
     */
    get(layerOrLayerType: ILayerProps | LayerType) {
        if (!layerOrLayerType) return undefined;
        return this.__behaviors[this.getKey(layerOrLayerType)] ?? undefined;
    }

    /**
     * 通过键获取图层行为
     * @param key - 图层行为的键
     * @returns 图层行为
     */
    getByKey(key: string) {
        return this.__behaviors[key] ?? undefined;
    }

    /**
     * 注册图层行为
     * @param key - 图层行为的键
     * @param behavior - 图层行为
     */
    setByKey(key: string, behavior: ILayerBehavior) {
        if (process.env.NODE_ENV !== 'production') {
            const requiredMethods = ['getMenuOverlapName', 'getMenuOverlapIcon'] as const;
            requiredMethods.forEach((method) => {
                if (typeof behavior[method] !== 'function') {
                    throw new Error(`Layer behavior "${key}" must implement ${method}`);
                }
            });
        }
        this.__behaviors[key] = behavior;
    }

    private __createKey(layerType: LayerType, role?: string) {
        if (role) {
            return `${layerType}-${role}`;
        }
        return layerType;
    }
}
